// The Foundation's organisation kinds and states (openapi Organization.kind, .state), in the founder's words.
export type OrgKind = "platform" | "product" | "customer";
export type OrgState = "pending_admin" | "active" | "inactive";
export type Org = { id: string; kind: OrgKind; state: OrgState; display_name: string; legal_name?: string };

const LABELS: Record<OrgKind, string> = { platform: "Platform", product: "Product", customer: "Customer" };
const STATES: Record<OrgState, string> = { pending_admin: "Pending owner", active: "Active", inactive: "Deactivated" };

export const kindLabel = (kind: OrgKind): string => LABELS[kind];
export const stateLabel = (state: OrgState): string => STATES[state] ?? state;

// deactivateOrganization (W6.1, W1.A5) refuses the platform and an organisation already deactivated (409).
export const canDeactivate = (org: { kind: OrgKind; state: string }): boolean =>
  org.kind !== "platform" && (org.state === "active" || org.state === "pending_admin");

// reactivateOrganization (W6.3) restores only a deactivated organisation (409 otherwise); platform administrators only.
export const canRestore = (org: { state: string }): boolean => org.state === "inactive";
